import React, { useEffect, useState } from "react";
import Header from "../../../components/Header";
import { driver } from "../../../common/svg";
import AdminCointainer from "../../Admin";
import { useForm } from "react-hook-form";
import { DriverData } from "../../../service/interfaces/Forms";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../../service/validation/driver";
import Input from "../../../components/FormInputs";
import PhoneInput from "../../../components/phoneinput";
import DatePicker from "../../../components/Datepicker";
import FormTitle from "../../../components/FormTitle";
import { ApiService } from "../../../service/api.service";
import { useNavigate, useParams } from "react-router-dom";
import { MASTER_URL } from "../../../common/common";
import CustomTabs from "../../../components/Tab";
import { DriverFormTabs } from "../../../common/tabs";
import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import PersonalDetails from "./SubTabs/PersonalDetails";
import AddressDetails from "./SubTabs/AddressDetails";
import BankDetails from "./SubTabs/BankDetails";

const ManageDriver = () => {
  const apiService = new ApiService();
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>("Personal Details");

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    control,
    setValue,
  } = useForm<DriverData>({
    resolver: yupResolver(validationSchema),
  });
  const [driverData, setDriverData] = useState<DriverData | null>(null);
  const getEmployeeData = async () => {
    let response: any = await apiService.getApi(`${MASTER_URL}/driver/get-one-route?driverId=${id}`);
    if (response.status === "200") {
      // let data: EmployeeData = { firstName: "", lastName: "", emailId: "", mobileNumber: "" }
      console.log("Employee Data", response.body);
      if (response.body) {
        setDriverData(response.body);
      }
    }
  }
  useEffect(() => {
    if (id) {
      getEmployeeData();
    }
  }, [id]);

  useEffect(() => {
    if (driverData) {
      reset(driverData);
    }
  }, [driverData, reset]);

  const onSubmit = async (data: DriverData) => {
    console.log("Form Data:", data);
    try {
      const payload = id ? { ...data, driverId: id } : data;
      const response: any = id
        ? await apiService.putApi(`${MASTER_URL}/driver/edit-route`, payload)
        : await apiService.postApi(
          `${MASTER_URL}/driver/register-route`,
          payload
        );

      if (response.status === "200") {
        reset();
        navigate(-1);
      } else {
        console.warn("Driver submission failed", response);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const cancel = () => {
    reset();
    navigate("/driver");
  };

  return (
    <div>
      <Header icon={driver} title="Add New Driver" showSearch={false} />
      <AdminCointainer>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="bg-white p-6 rounded-lg">
            <FormTitle title="Driver Details" />
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-1">
              <Input
                register={register}
                name="driverDetails.firstName"
                errors={errors}
                label="First Name"
                placeholder="Enter First Name"
              />
              <Input
                register={register}
                name="driverDetails.lastName"
                errors={errors}
                label="Last Name"
                placeholder="Enter Last Name"
              />
              <Input
                register={register}
                name="driverDetails.emailId"
                errors={errors}
                label="Email"
                placeholder="Enter Email"
              />
              <PhoneInput<DriverData>
                label="Mobile Number"
                name="driverDetails.mobileNumber"
                defaultCountry="IN"
                type="tel"
                errors={errors}
                control={control}
                maxLength={10}
                value={watch("driverDetails.mobileNumber")}
                onChange={({ phoneNumber }) =>
                  setValue("driverDetails.mobileNumber", phoneNumber)
                }
              />
              <Input
                register={register}
                name="driverDetails.licenseNumber"
                errors={errors}
                label="License Number"
                placeholder="Enter License Number"
              />
              <Input
                register={register}
                name="driverDetails.licenseType"
                errors={errors}
                label="License Type"
                placeholder="Enter License Type"
              />
              <DatePicker
                label="License Expiry"
                onDateChange={(date: string) => {
                  setValue("driverDetails.licenseExpiry", new Date(date));
                }}
                register={register("driverDetails.licenseExpiry")}
                name="driverDetails.licenseExpiry"
                errors={errors}
                allowPastDates={false} // Set to false since license expiry should be in future
                defaultValue={driverData?.driverDetails?.licenseExpiry ? new Date(driverData.driverDetails.licenseExpiry).toISOString().split('T')[0] : undefined}
              />
              <Input
                register={register}
                name="driverDetails.panNumber"
                errors={errors}
                label="PAN Number"
                placeholder="Enter PAN Number"
              />
              <Input
                register={register}
                name="driverDetails.aadhaarNumber"
                errors={errors}
                label="Aadhaar Number"
                placeholder="Enter Aadhaar Number"
              />
              <Input
                register={register}
                name="driverDetails.alternativePhoneNumber"
                errors={errors}
                label="Alternative Phone"
                placeholder="Enter Alternative Phone Number"
              />
              <Input
                register={register}
                name="driverDetails.alternativeEmailId"
                errors={errors}
                label="Alternative Email"
                placeholder="Enter Alternative Email"
              />
              <Input
                register={register}
                name="driverDetails.relationWithDriver"
                errors={errors}
                label="Relation"
                placeholder="Father, Spouse, etc."
              />
              <ToggleSwitch
                name="driverDetails.inhouseDriver"
                label="Inhouse Driver"
                errors={errors}
                register={register}
              />

              {/* <Input
                register={register}
                name="driverDetails.inhouseDriver"
                errors={errors}
                label="Inhouse Driver"
                type="checkbox"
              /> */}
            </div>
          </div>

          <div className="mt-2">
            <CustomTabs tabs={DriverFormTabs} onTabChange={setActiveTab} />
          </div>
          {
            activeTab === "Personal Details" && <PersonalDetails register={register} errors={errors} setValue={setValue} data={driverData} />
          }
          {
            activeTab === "Address Details" && <AddressDetails register={register} errors={errors} setValue={setValue} />
          }
          {
            activeTab === "Bank Details" && <BankDetails register={register} errors={errors} setValue={setValue} />
          }

          <div className="gap-4 flex items-center justify-end mr-8 self-end mt-4">
            <button
              type="button"
              onClick={cancel}
              className="w-36 h-10 rounded-lg text-[#444FBD] border border-[#444FBD] hover:border-gray-400 transition duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="w-36 h-10 rounded-lg bg-[#444FBD] text-white transition duration-200"
            >
              Submit
            </button>
          </div>
        </form>
      </AdminCointainer>
    </div>
  );
};

export default ManageDriver;
